import { twMerge } from 'tailwind-merge'
import NextLink from 'next/link'

type Props = {
  href: string | any
} & (React.ComponentPropsWithoutRef<typeof NextLink>)

export function MenuLink({ className, children, ...props }: Props) {
  className = twMerge('menu-button', className)
  return (
    <NextLink hrefLang='en' className={className} {...props}>
      {children}
    </NextLink>
  )
}